import {
  Box,
  Button,
  Flex,
  Image,
  Link,
  SimpleGrid,
  Text,
} from "@chakra-ui/core";
import React from "react";
import facebook from "../../../../static/assets/icons/facebook.png";
import linkedIn from "../../../../static/assets/icons/LI-In-Bug.png";
import whatsapp from "../../../../static/assets/icons/whatsapp.png";
import mail from "../../../../static/assets/icons/mail.png";
// import { Link } from 'react-router-dom';

const LinkIconFetch = {
  mail: mail,
  linkedIn: linkedIn,
  facebook: facebook,
  whatsapp: whatsapp,
};

const ShareJobs = ({ links }) => (
  <Box>
    <Text my="5">Share Job</Text>
    <SimpleGrid minChildWidth="40px" spacing="0.25em">
      {links.map((each) => (
        <Link href={each.value} key={each.value}>
          <Image src={LinkIconFetch[each.name]} size="32px" />
        </Link>
      ))}
    </SimpleGrid>
  </Box>
);

const EachDetail = ({ title, value }) => (
  <SimpleGrid minChildWidth="100px" spacing="1em" my="5">
    <Text color="grey" fontSize="sm">
      {title}
    </Text>
    <Text fontSize="sm">{value}</Text>
  </SimpleGrid>
);

function SummaryCard({ jobPosting }) {
  return (
    <Flex direction="column" p="5" backgroundColor="#eeeeee">
      <Flex
        my="5"
        direction={{ lg: "row", md: "row", sm: "column", xs: "column" }}
        align="center"
      >
        <Image src={jobPosting.posted.img} size="100px" />
        <Flex ml="5" direction="column">
          <Text fontSize="lg">{jobPosting.posted.name}</Text>
          <Text fontSize="md" my="2">
            {jobPosting.posted.role}
          </Text>
          <Text>{jobPosting.posted.location}</Text>
        </Flex>
      </Flex>
      <Button backgroundColor="#41bb93">Message</Button>
      <ShareJobs links={jobPosting.links} />
      <Box my="5">
        <Text mb="2" fontSize="md">
          Job Details
        </Text>
        <EachDetail title="Salary" value={jobPosting.job.salary} />
        <EachDetail title="Industry" value={jobPosting.job.industry} />
        <EachDetail
          title="Functional Area"
          value={jobPosting.job.functional.join(", ")}
        />
        <EachDetail title="Role Category" value={jobPosting.job.category} />
        <EachDetail
          title="Employment Type"
          value={jobPosting.job.type.join(", ")}
        />
      </Box>
      <Box my="5">
        <Text fontSize="md">Key Skills</Text>
        <Text my="2" fontSize="sm" color="grey">
          {jobPosting.skills.join(", ")}
        </Text>
      </Box>
    </Flex>
  );
}

export default SummaryCard;
